import * as React from 'react';
import Highlight, { defaultProps } from 'prism-react-renderer';
import theme from 'prism-react-renderer/themes/palenight';
import Loadable from 'react-loadable';
import LoadingProvider from './loading';

/** Removes the last token from a code example if it's empty. */
function cleanTokens(tokens) {
  const tokensLength = tokens.length;

  if (tokensLength === 0) {
    return tokens;
  }
  const lastToken = tokens[tokensLength - 1];

  if (lastToken.length === 1 && lastToken[0].empty) {
    return tokens.slice(0, tokensLength - 1);
  }
  return tokens;
}

/** Copy the  code in the code snippet. */
const copyToClipboard = str => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(str).then(
      function () {
        console.log("Copying to clipboard was successful!");
      },
      function (err) {
        console.error("Could not copy text: ", err);
      }
    );
  } else if (window.clipboardData) {
    // Internet Explorer
    window.clipboardData.setData("Text", str);
  }
};

const LoadableComponent = Loadable({
  loader: () => import('./LiveProvider'),
  loading: LoadingProvider,
});

/* eslint-disable react/jsx-key */
const CodeBlock = ({ children: code, ...props }) => {
  const [isCopied, setIsCopied] = React.useState(false);
  const cleanCode = code.replace(/\n´-/g, '\n-');

  if (props['react-live']) {
    return <LoadableComponent code={code} />;
  } else {
    const lang = props.className ? props.className.split('-')[1] : null;
    return (
      <div style={{ position: "relative", marginBottom: "2.5px", maxHeight: "100vh", overflow: "auto" }}>
        <button
            onClick={() => {
              copyToClipboard(cleanCode);
              setIsCopied(true);
              setTimeout(() => setIsCopied(false), 1000);
            }}
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              marginTop: "0.5rem",
              marginRight: "0.5rem",
              padding: "3.5px 8px",
              background: "#1C5093",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              color: "#E2E8F0",
              fontSize: "14px",
              fontFamily: "sans-serif",
              lineHeight: "1",
            }}
          >
            {isCopied ? "¡Copiado! 💾" : "💾"}
          </button>
          <Highlight {...defaultProps} code={code} language={lang} theme={theme}>
            {({ className, style, tokens, getLineProps, getTokenProps }) => (
              <pre className={className + ' pre'} style={style} p={3}>
                {cleanTokens(tokens).map((line, i) => {
                  let lineClass = {};

                  let isDiff = false;

                  console.log(lang);

                  if (line[0] && line[0].content[0] === '´' && line[0].content[1] === '-') {
                    line[0].content = line[0].content.substring(1);
                  } else if (line[0] && line[0].content.length && line[0].content[0] === '+') {
                    lineClass = { backgroundColor: 'rgba(76, 175, 80, 0.2)' };
                    isDiff = true;
                  } else if (line[0] && line[0].content.length && line[0].content[0] === '-') {
                    lineClass = { backgroundColor: 'rgba(244, 67, 54, 0.2)' };
                    isDiff = true;
                  } else if (line[0] && line[0].content === '' && line[1] && line[1].content === '+') {
                    lineClass = { backgroundColor: 'rgba(76, 175, 80, 0.2)' };
                    isDiff = true;
                  } else if (line[0] && line[0].content === '' && line[1] && line[1].content === '-') {
                    lineClass = { backgroundColor: 'rgba(244, 67, 54, 0.2)' };
                    isDiff = true;
                  }
                  const lineProps = getLineProps({ line, key: i });

                  lineProps.style = lineClass;
                  const diffStyle = {
                    userSelect: 'none',
                    MozUserSelect: '-moz-none',
                    WebkitUserSelect: 'none',
                  };

                  let splitToken;

                  return (
                    <div {...lineProps} key={line + i}>
                      {line.map((token, key) => {
                        if (isDiff) {
                          if (
                            (key === 0 || key === 1) &
                            (token.content.charAt(0) === '+' || token.content.charAt(0) === '-')
                          ) {
                            if (token.content.length > 1) {
                              splitToken = {
                                types: ['template-string', 'string'],
                                content: token.content.slice(1),
                              };
                              const firstChar = {
                                types: ['operator'],
                                content: token.content.charAt(0),
                              };

                              return (
                                <React.Fragment key={token + key}>
                                  <span
                                    {...getTokenProps({ token: firstChar, key })}
                                    style={diffStyle}
                                  />
                                  <span {...getTokenProps({ token: splitToken, key })} />
                                </React.Fragment>
                              );
                            } else {
                              return <span {...getTokenProps({ token, key })} style={diffStyle} />;
                            }
                          }
                        }
                        return <span {...getTokenProps({ token, key })} />;
                      })}
                    </div>
                  );
                })}
              </pre>
            )}
          </Highlight>
      </div>
    );
  }
};

export default CodeBlock;
